import React from "react";
// import ServicesBlock from "../components/ServicesBlock";
// import TeamCard from "../components/TeamCard";
import MDsirImage from "../assets/images/seatech_md.jpg";
import "./css/sections.css";

function team() {
  // if there will be more team members us this
  // card component is already created

  //   const sampleCards = [
  //     {
  //       image:
  //        MDsirImage,
  //       name: "Mr. Nalinikant N. Mishra",
  //       description:
  //         "Founder & Managing Director",
  //       links: {
  //         twitter: "https://twitter.com",
  //         facebook: "https://facebook.com",
  //         instagram: "https://instagram.com",
  //         linkedin: "https://linkedin.com",
  //       },
  //     },
  //   ];

  return (
    <div id="team" className="team-container">
      <div className="team-inner-container">
        <div className="team-header">
          <h1>MANAGING DIRECTOR</h1>
          <div className="divider"></div>
        </div>
        {/* <div
          style={{
            display: "flex",
            gap: "2rem",
            padding: "2rem",
            // backgroundColor: "#f5f5f5",
            minHeight: "fit-content",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        > */}
        {/* {sampleCards.map((card, index) => (
            <TeamCard
              key={index}
              image={card.image}
              name={card.name}
              description={card.description}
              links={card.links}
            />
          ))} */}
        {/* </div> */}
        <div
        className="team-content-container"
          // style={{ display: "flex", alignItems: "center", marginTop: "50px" }}
        >
          <div className="team-image-container">
            <img
              src={MDsirImage}
              className="team-image"
              alt="Managing Director"
            />
            <label className="team-name">Mr. Nalinikant N. Mishra</label>
          </div>
          <div className="team-content">
            <h2>Our Mission</h2>
            <p className="description">
              A commitment to find the best solution for the individual needs of
              each client, or as we like to think, each business partner.
            </p>
            <h2>Our Vision</h2>
            <p className="description">
              We aspire to fulfill our dream of providing quality services to
              our valued clients through logistics, design & solutions.
            </p>
            <h2>Our Purpose</h2>
            <p className="description">
              Committed to provide a holistic solution to our clients, we are
              always ready to meet our clients' requirements efficiently.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default team;
